<template>
  <div v-if="showBuyBtn" class="info target fade" @click="clickOutSide($event)">
    <!-- S 立即购买 -->
    <div
      class="button-buy-wrap button-buy--qrcode button-buy--suit buy-now"
      @mouseover="popup(true)"
      @mouseout="popup(false)"
      @click="buyClick($event)"
    >
      <div class="game-box-btn game-buy-btn">
        <div class="nt-button nt-button--default">
          <a href="javascript:" target="_self">
            <i class="button-icon">
              <svg
                id="right-stroke-arrow"
                xmlns="http://www.w3.org/2000/svg"
                width="60"
                height="60"
                viewBox="0 0 60 60"
                aria-labelledby="right-stroke-arrow"
                role="presentation"
                fill="currentColor"
              >
                <g>
                  <g>
                    <path
                      d="M39,27.7c0,0-9.6-9.6-10.9-10.8c-1.4-1.2-3.6-1.2-5,0c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2
	l8.6,8.5l-8.6,8.5c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2c1.4,1.2,3.6,1.2,5,0C29.4,41.9,39,32.3,39,32.3
	c0.1-0.1,0.2-0.1,0.2-0.2C40.4,30.8,40.2,28.9,39,27.7z"
                      fill="currentColor"
                    ></path>
                  </g>
                </g>
              </svg>
            </i>
            立即购买
          </a>
        </div>
      </div>
      <div v-show="showPop" class="popbox buy-popbox">
        <div class="button-buy-inner">
          <div v-if="jdBuyLink" class="game-box-btn game-box-btn--top">
            <div
              class="nt-button nt-button--default"
              @click="openStore(jdBuyLink, 'jd')"
            >
              <a href="javascript:void(0);" target="_blank">
                <i class="button-icon">
                  <svg
                    id="right-stroke-arrow"
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    aria-labelledby="right-stroke-arrow"
                    role="presentation"
                    fill="currentColor"
                  >
                    <g>
                      <g>
                        <path
                          d="M39,27.7c0,0-9.6-9.6-10.9-10.8c-1.4-1.2-3.6-1.2-5,0c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2
	l8.6,8.5l-8.6,8.5c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2c1.4,1.2,3.6,1.2,5,0C29.4,41.9,39,32.3,39,32.3
	c0.1-0.1,0.2-0.1,0.2-0.2C40.4,30.8,40.2,28.9,39,27.7z"
                          fill="currentColor"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </i>
                京东官方旗舰店
              </a>
            </div>
          </div>
          <div v-if="tmBuyLink" class="game-box-btn game-box-btn--bottom">
            <div
              class="nt-button nt-button--default"
              @click="openStore(tmBuyLink, 'tm')"
            >
              <a href="javascript:void(0);" target="_blank">
                <i class="button-icon">
                  <svg
                    id="right-stroke-arrow"
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    aria-labelledby="right-stroke-arrow"
                    role="presentation"
                    fill="currentColor"
                  >
                    <g>
                      <g>
                        <path
                          d="M39,27.7c0,0-9.6-9.6-10.9-10.8c-1.4-1.2-3.6-1.2-5,0c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2
	l8.6,8.5l-8.6,8.5c-0.1,0.1-0.2,0.2-0.4,0.4c-1.1,1.3-0.9,3.1,0.4,4.2c1.4,1.2,3.6,1.2,5,0C29.4,41.9,39,32.3,39,32.3
	c0.1-0.1,0.2-0.1,0.2-0.2C40.4,30.8,40.2,28.9,39,27.7z"
                          fill="currentColor"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </i>
                天猫授权店铺
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- E 立即购买 -->
  </div>
</template>

<script>
import { pgvEventReport } from '../tcss-report';
function getPurchaseUrl(purchaseUrls, key) {
  const result = purchaseUrls.filter((item) => {
    return item.key === key;
  });
  return (result.length && result[0].url) || '';
}
export default {
  props: {
    urls: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showPop: false,
      JD: {
        key: 'JD',
        name: '京东官方旗舰店'
      },
      TM: {
        key: 'TM',
        name: '天猫官方旗舰店'
      },
      WX_STORE: {
        key: 'WXSTORE',
        name: '微信官方商城'
      }
    };
  },
  computed: {
    jdBuyLink() {
      return getPurchaseUrl(this.urls, this.JD.key);
    },
    tmBuyLink() {
      return getPurchaseUrl(this.urls, this.TM.key);
    },
    showBuyBtn() {
      return this.jdBuyLink || this.tmBuyLink;
    }
  },
  mounted() {
    document.addEventListener('click', () => {
      this.popup(false);
    });
  },
  methods: {
    buyClick(event) {
      // 阻止弹框
      event.preventDefault();
      event.stopPropagation();
    },
    clickOutSide(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.showPop) {
        this.showPop = false;
      }
    },
    popup(show) {
      this.showPop = show;
    },
    openStore(url, pv) {
      pgvEventReport(`mariocart_coursepack.open_store_${pv}`);
      window.open(url);
    }
  }
};
</script>

<style></style>
